import { setMonitoringUser } from "@/core/monitoring";

type AssessmentUserPayload = {
  personId?: string | null;
  firstName?: string | null;
  anonymousId: string;
};

/**
 * Identify the Datadog RUM user from a retrieved assessment.
 * Uses personId when available (verified user); falls back to anonymousId
 * so returning sessions are always attributable in Datadog.
 */
export function setMonitoringUserFromAssessment(assessment: AssessmentUserPayload): void {
  const id = assessment.personId || assessment.anonymousId;
  if (!id) return;

  setMonitoringUser({
    id,
    name: assessment.firstName ?? undefined,
    ...(assessment.personId ? { personId: assessment.personId } : {}),
    ...(assessment.anonymousId ? { anonymousId: assessment.anonymousId } : {}),
  });
}
